import type { ComponentType, ReactNode, SVGProps } from 'react';
import { cn } from '@/lib/utils';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

interface Props {
  Icon?: IconComponent;
  title: ReactNode;
  description?: ReactNode;
  /** CTA slot — typically a shadcn Button/Link. */
  action?: ReactNode;
  className?: string;
}

// The single "there's nothing here" pattern. Used by DataTable when rows are
// empty and by page-level empty states (no issues, no releases, etc.).
export function EmptyState({ Icon, title, description, action, className }: Props) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-md border border-dashed bg-muted/40 p-8 text-center',
        className,
      )}
      data-testid="empty-state"
      role="status"
    >
      {Icon && <Icon className="h-8 w-8 text-muted-foreground" aria-hidden="true" />}
      <div className="text-sm font-medium text-foreground">{title}</div>
      {description && <div className="text-xs text-muted-foreground">{description}</div>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
